import { Numeric2BoxOutlineIcon } from './Numeric2BoxOutlineIcon';

/**
 * author: Google
 * id 0C255402-1176-46B5-B38C-60118732FCC7
 * name numeric-2-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-2-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number2BoxOutlineIcon = Numeric2BoxOutlineIcon;
export default Number2BoxOutlineIcon